const TELEGRAM_USERNAME_PATTERN = /^[a-zA-Z0-9_]{5,32}$/;
const PHONE_FORMAT_PATTERN = /^\+?[\d\s().-]+$/;

export const normalizePhoneNumber = (phone?: string): string | null => {
    const value = phone?.trim();

    if (!value || !PHONE_FORMAT_PATTERN.test(value)) {
        return null;
    }

    const digits = value.replace(/\D/g, "");

    if (digits.length < 8 || digits.length > 15) {
        return null;
    }

    return `+${digits}`;
};

export const getViberContactLink = (phone?: string): string | null => {
    const normalizedPhone = normalizePhoneNumber(phone);
    return normalizedPhone ? `viber://chat?number=${encodeURIComponent(normalizedPhone)}` : null;
};

export const getWhatsAppContactLink = (phone?: string): string | null => {
    const normalizedPhone = normalizePhoneNumber(phone);
    return normalizedPhone ? `https://wa.me/${normalizedPhone.slice(1)}` : null;
};

export const getTelegramContactLink = (telegram?: string): string | null => {
    const username = telegram
        ?.trim()
        .replace(/^(?:https?:\/\/)?(?:www\.)?(?:t\.me|telegram\.me)\//i, "")
        .replace(/^@/, "")
        .replace(/\/$/, "");

    if (!username || !TELEGRAM_USERNAME_PATTERN.test(username)) {
        return null;
    }

    return `https://t.me/${username}`;
};
